import React from 'react';
import { useSelector } from 'react-redux';
import { Discount } from 'blocks/Pricing/constants';
import {
  customerIdSelector,
  discountSelector,
  isInvoicePastDueSelector,
} from 'redux/modules/pricing';
import BillingHistoryLink from '../BillingHistoryLink';
import CreditCardRecoveryBanner, {
  useCreditCardRecoveryBanner,
} from '../CreditCardRecoveryBanner';
import BaseFreeSubscription from './BaseFreeSubscription';
import { block } from './utils';

export interface FreeSubscriptionProps {}

const FreeSubscription: React.FC<FreeSubscriptionProps> = () => {
  const discount = useSelector(discountSelector);
  const customerId = useSelector(customerIdSelector);
  const invoicePastDue = useSelector(isInvoicePastDueSelector);
  const { show: showCreditCardRecovery } = useCreditCardRecoveryBanner();

  return (
    <>
      {showCreditCardRecovery && (
        <CreditCardRecoveryBanner className={block('banner')} />
      )}

      <BaseFreeSubscription
        message={
          discount === Discount.BOGO
            ? "🎉 You've got BOGO Headliner! 🎉"
            : invoicePastDue || customerId
            ? 'Your plan was cancelled :('
            : "You've got Headliner for free!"
        }
        subMessage={
          discount === Discount.BOGO ? (
            'For a limited time, buy one plan, get one free! Check our BOGO deals:'
          ) : invoicePastDue || customerId ? (
            <span>
              However, you can easily reactivate below! Also{' '}
              <BillingHistoryLink>
                here is your billing history
              </BillingHistoryLink>
              .
            </span>
          ) : (
            'Interested in taking your video making to the next level? Check out our upgrade options:'
          )
        }
      />
    </>
  );
};

export default FreeSubscription;
